export default "__VITE_ASSET__gr4Wo259__"